import { render, staticRenderFns } from "./CustomerWsuDetail.vue?vue&type=template&id=297fb8b9&scoped=true&"
import script from "./CustomerWsuDetail.vue?vue&type=script&lang=js&"
export * from "./CustomerWsuDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297fb8b9",
  null
  
)

export default component.exports